import { render } from "./BlFormFieldTextarea.vue?vue&type=template&id=163fcc74&scoped=true"
import script from "./BlFormFieldTextarea.vue?vue&type=script&lang=js"
export * from "./BlFormFieldTextarea.vue?vue&type=script&lang=js"

import "./BlFormFieldTextarea.vue?vue&type=style&index=0&id=163fcc74&scoped=true&lang=css"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163fcc74"]])

export default __exports__